import React from 'react';
import styled from 'styled-components';

import theme from 'styles/theme';

import Label from 'components/Label';

const StyledInput = styled.input`
  width: 100%;
  font-size: 14px;
  padding: 10px 15px;
  background: ${theme.B400};
  border: 1px solid ${theme.B600};
  border-radius: 3px;
  box-shadow: none;
  color: ${theme.font_primary};
  outline: none;
  transition: background 300ms, border-color 300ms, padding 300ms;

  &:disabled {
    background: transparent;
    border-color: transparent;
    padding: 0;
  }
`;

const Input = ({ label, style, ...props }) => (
  <div style={style}>
    {label && <Label>{label}</Label>}
    <StyledInput type="text" autoComplete="off" {...props} />
  </div>
);

export default Input;



// WEBPACK FOOTER //
// ./src/components/Input.js